import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const hubspotWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-hubspot/web/HubspotPage',
    label: 'Connect HubSpot CRM and emit contact, company, and deal events to your automations.',
  },
};
